import axios from "axios";

import useApp from "./useApp";

import useApp2 from "./../../APP/Hooks/useApp";

import useRequestError from "./useRequestError";

import useLocalStorage from "./useLocalStorage";

function normalizeUrl(url = "") {
  // Split protocol (http://, https://, etc.) from the rest
  const [protocol, rest] = url.split("://");

  // Normalize the rest (remove consecutive slashes)
  const normalized = rest.replace(/\/{2,}/g, "/");

  return `${protocol}://${normalized}`;
}

function useAxios() {
  const handleRequestError = useRequestError();

  const { ipLocationProps, messageProps, loadingProps } = useApp();

  const { memberInfo } = useLocalStorage();

  const { token } = useApp2();

  const request = async (requestObject = {}) => {
    const {
      method = "GET",
      url = "",
      baseUrl = "https://api.v2.mkombozihealthcare.com/api",
      headers = {},
      body = {},
      params = {},
      showError = true,
      showLoadingModal = true,
      loadingFunc = null,
      sendBearerToken = true,
      responseType = "json",
      showSuccessModal = true,
    } = requestObject;

    try {
      if (showLoadingModal === true) {
        loadingProps?.showLoader();
      }
      if (!method || !url) {
        throw { custom: true, message: "Method and url required" };
      }

      if (sendBearerToken) {
        let jwt = "";

        if (token) {
          jwt = token;
        } else {
          const { token } = memberInfo();
          jwt = token;
        }
        headers.Authorization = `Bearer ${jwt}`;
      }

      if (ipLocationProps?.ipLocation) {
        headers.geoLocation = JSON.stringify(ipLocationProps?.ipLocation);
      }

      if (ipLocationProps?.ipInfoLocation) {
        headers.ipLocation = JSON.stringify(ipLocationProps?.ipInfoLocation);
      }

      const res = await axios({
        headers,
        method,
        url: normalizeUrl(`${baseUrl}/${url}`),
        data: body,
        params,
        responseType,
      });

      if (showSuccessModal) {
        messageProps?.updateMessageModal({
          isVisible: true,
          header: "Success",
          message: res?.data?._message || res?.data?.message || "Success",
        });
      }

      return { _error: false, ...res };
    } catch (error) {
      console.log("ERROR IN");
      console.log(error);
      if (showError) {
        handleRequestError(error);
      }

      return {
        _error: true,
        error,
        status: error?.response?.status || null,
        data: error?.response?.data,
      };
    } finally {
      if (typeof loadingFunc === "function") {
        loadingFunc(false);
      }
      if (showLoadingModal) {
        loadingProps.hideLoader();
      }
    }
  };

  return request;
}

export default useAxios;
